import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import oabNumberFormat from 'component/masks/oabNumberFormat.component';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '25ch',
  },
}));

// to set Parent value pass as prop the setState of parent variable to setValue
// Ex.: Parent -> -> <thisComponent setValue={setState} />
export default function JusInput(props) {
  const classes = useStyles();
  const [values, setValues] = React.useState({
    input: '',
    showPassword: false,
  });

  const handleChange = prop => event => {
    setValues({ ...values, [prop]: event.target.value });
    props.setValue(event.target.value, props.property);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <div className="row">
      <Grid
        container
        spacing={1}
        alignItems="flex-end"
        style={{ justifyContent: 'center' }}
      >
        <Grid item>
          <props.IconComponent style={{ color: '#707070' }} />
        </Grid>
        <Grid item>
          {props.isPassword ? (
            <FormControl
              className={clsx(classes.margin, classes.textField)}
              style={{ minWidth: '300px', margin: '0px' }}
            >
              <InputLabel
                htmlFor="standard-adornment-password"
                error={props.setError}
              >
                {props.label + ' *'}
              </InputLabel>
              <Input
                type={values.showPassword ? 'text' : 'password'}
                value={values.input}
                onChange={handleChange('input')}
                error={props.setError}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          ) : (
            [
              props.isRequired ? (
                <TextField
                  required
                  error={props.setError}
                  label={props.label}
                  value={values.input}
                  onChange={handleChange('input')}
                  style={{ minWidth: '300px' }}
                />
              ) : (
                <FormControl
                  className={clsx(classes.margin, classes.textField)}
                  style={{ minWidth: '300px', margin: '0px' }}
                  error={props.setError}
                >
                  <InputLabel>
                    {props.label}
                  </InputLabel>
                  <Input
                    type="text"
                    style={{ minWidth: '300px' }}
                    inputComponent={oabNumberFormat}
                    value={values.input}
                    onChange={handleChange('input')}
                    error={props.setError}
                  />
                </FormControl>
              ),
            ]
          )}
        </Grid>
      </Grid>
    </div>
  );
}
